<template>
  <el-container class='container'>
    <el-aside width="200px">
      <el-menu class='sideMenu' :router="true" :default-active="$route.path">
          <el-menu-item index="/dashboard">
            <icon name="table" class="el-icon-menu icon"></icon>
            <span>Dashboard</span>
          </el-menu-item>
          <el-menu-item index="/">
            <icon name="regular/edit" class="el-icon-menu icon"></icon>
            <span>Create Report</span>
          </el-menu-item>
          <el-menu-item v-if="getRoles(user.roles).includes('admin')" index="/addContract">
            <icon name="regular/copy" class="el-icon-menu icon"></icon>
            <span>Contracts</span>
          </el-menu-item>
          <el-menu-item v-if="getRoles(user.roles).includes('admin')" index="/users">
            <icon name="regular/user-circle" class="el-icon-menu icon"></icon>
            <span>Users</span>
          </el-menu-item>
          <el-menu-item v-if="getRoles(user.roles).includes('admin')" index="/reports">
            <icon name="regular/chart-bar" class="el-icon-menu icon"></icon>
            <span>Status Reports</span>
          </el-menu-item>
          <el-menu-item v-if="getRoles(user.roles).includes('admin')" index="/teams">
            <icon name="users" class="el-icon-menu icon"></icon>
            <span>Teams</span>
          </el-menu-item>
          <el-menu-item v-if="getRoles(user.roles).includes('manager')" index="/your-team">
            <icon name="users" class="el-icon-menu icon"></icon>
            <span>Your Team</span>
          </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main class="main">
      <div class="header">
        <h1 class='title'>{{$route.name}}</h1>
        <div class='header'>
          Hello, {{userName}}
          <div style="marginLeft: 20px" @click="logout">
            <icon name="sign-out-alt" class="el-icon-menu icon"></icon>
          </div>
        </div>
      </div>
      <transition
        v-on:before-enter="beforeEnter"
        mode="out-in"
        appear
        v-on:enter="enter"
        v-on:leave="leave"
      >
        <router-view/>
      </transition>
    </el-main>
  </el-container>
</template>

<script>
import { Power1, TweenLite } from 'gsap';
import { auth, database } from '../main.js'
export default {
  data () {
    return {
      userName: auth.currentUser.displayName,
      user: {}
    }
  },
  async created () {
    console.log('hello')
    const user = await database.ref(`/users/${auth.currentUser.uid}`).once('value')
    this.user = user.val()
  },
  methods: {
    getRoles (roles) {
      return roles ? Object.keys(roles) : []
    },
    logout () {
      auth.signOut()
        .then(() => {
          this.$router.replace('login');
      });
    },
    beforeEnter (el) {
      el.style.opacity = 0
    },
    enter (el, done) {
      TweenLite.fromTo(
        el,
        0.3,
        {
          opacity: 0,
          cx: 500
        },
        {
          scaleX: 1,
          scaleY: 1,
          opacity: 1,
          cx: 0,
          ease: Power1.easeIn,
          onComplete: () => {
            done()
          }
        }
      )
     },
    leave (el, done) {
      TweenLite.fromTo(
        el,
        0.3,
        {
          opacity: 1
        },
        {
          opacity: 0,
          ease: Power1.easeOut,
          onComplete: () => {
            done()
          }
        }
      )
    }
  }
};
</script>

<style scoped>
  .header {
    display: flex;
    alignItems: center;
    justify-content: space-between;
  }
  .icon {
    width: 18px;
    height: 18px;
  }
  .title {
    margin-top: 0px
  }
  .main {
    width: calc(100vw - 200px);
    background: #fafafa;
    overflow: scroll;
    position: relative
  }
 .container {
   display: grid;
   grid-template-columns: 200px auto;
   height: 100vh
 }
 .sideMenu {
   height: 100%;
 }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue